import { Link } from '@calendly/ui/components/link'

export const OnboardingGuideLink = ({ children }) => (
  <Link rel="noopener" target="_blank" href="https://help.calendly.com/hc/en-us/articles/13053308362135">{children}</Link>
)

export const DomainReportHelpCenterLink = ({ children }) => (
  <Link rel="noopener" target="_blank" href="https://help.calendly.com/hc/en-us/articles/14944827902743">{children}</Link>
)
